enum AdditionOwnershipType {
    Heir = 1,
    Remainderman,
    NonExecutive,
    NonParticipating,
    TransferOnDeath,
    NakedOwner
}

export const AddlOwnershipRatifyList = [
    AdditionOwnershipType.Heir,
    AdditionOwnershipType.NonParticipating
];

export const ExcludeMineralOwnerList = [
    AdditionOwnershipType.NonExecutive,
    AdditionOwnershipType.NonParticipating
];

export default AdditionOwnershipType;



// WEBPACK FOOTER //
// ./src/models/tract_detail/AdditionalOwnershipType.ts